import React from 'react';
import { get } from 'lodash';
import { TranslateHTML } from 'core/translate';
import useImage from '../../common/images/useImage';
import FallbackCgi from '../../common/cgi/FallbackCgi';

const AddedList = ({ option, isPackageOption }) => {
  const { description, largeImageUrl, hierarchy, longCfd, disclaimer } = option;
  const optionType = get(hierarchy, 'category');
  const { hasError } = useImage(largeImageUrl);

  return (
    <div
      className={
        isPackageOption
          ? 'option-conflict-confirmation-package__container'
          : 'option-conflict-confirmation-option__container'
      }>
      <div className="option-conflict__image-container">
        {hasError ? (
          <div className="option-conflict__image-fallback">
            <FallbackCgi hideLabel={true} />
          </div>
        ) : (
          <img
            className={
              optionType === 'exterior.color'
                ? 'option-conflict__color-chip'
                : 'option-conflict__image'
            }
            src={largeImageUrl}
            alt={description}
          />
        )}
      </div>
      <div className="option-conflict-confirmation__container">
        <div
          dangerouslySetInnerHTML={{ __html: description }}
          className="option-conflict-confirmation__description"
        />
        {isPackageOption && (
          <>
            <div
              className="option-conflict__list-container"
              dangerouslySetInnerHTML={{ __html: longCfd }}
            />
            {disclaimer && (
              <div
                className="option-conflict__package-disclaimer"
                dangerouslySetInnerHTML={{ __html: disclaimer }}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

const RemovedList = ({ description, details, disclaimer }) => {
  return (
    <li>
      <span
        dangerouslySetInnerHTML={{ __html: description }}
        className="option-conflict-confirmation__description"
      />
      {details && (
        <div
          className="option-conflict__list-container"
          dangerouslySetInnerHTML={{ __html: details }}
        />
      )}
      {disclaimer && (
        <div
          className="option-conflict__list-container"
          dangerouslySetInnerHTML={{ __html: disclaimer }}
        />
      )}
    </li>
  );
};

const OptionsList = ({
  options,
  label,
  isAddedSection,
  isPackageOption,
  className,
}) => {
  return options ? (
    <div className="option-conflict-containter__inner">
      <div className="option-conflict__label">{label}</div>
      {isAddedSection ? (
        <div className={className}>
          {options.map((option) => {
            return (
              <AddedList
                option={option}
                key={option.code}
                isPackageOption={isPackageOption}
              />
            );
          })}
        </div>
      ) : (
        <ul className="options-conflict__options-list-container">
          {options.map((option) => {
            return (
              <RemovedList
                description={option.description}
                details={isPackageOption && option.longCfd}
                disclaimer={isPackageOption && option.disclaimer}
                key={option.code}
              />
            );
          })}
        </ul>
      )}
    </div>
  ) : null;
};

const getOptionDescription = (option) =>
  option.formattedConfig || option.shortCFD || option.description;

const OptionConflictConfirmation = (props) => {
  const { option, conflictConfig, priceContainer } = props;
  const { selected } = option;

  const added = get(conflictConfig, 'config.toggleCheck.structured.added', []);

  const removed = get(
    conflictConfig,
    'config.toggleCheck.structured.deleted',
    []
  );

  const { packages: addedPackages, options: addedOptions } = added || [];
  const { packages: removedPackages, options: removedOptions } = removed || [];

  return (
    <>
      <div className="option-conflict__header">
        {selected ? (
          <TranslateHTML
            value="conflict.removing.header.v3"
            description={getOptionDescription(option)}
          />
        ) : (
          <TranslateHTML
            value="conflict.adding.header.v3"
            description={getOptionDescription(option)}
          />
        )}
      </div>
      <div className="option-conflict__summary">
        <div className="option-conflict__list-container">
          <ul>
            {addedPackages && <li>{addedPackages.label}</li>}
            {addedOptions && <li>{addedOptions.label}</li>}
            {removedPackages && <li>{removedPackages.label}</li>}
            {removedOptions && <li>{removedOptions.label}</li>}
          </ul>
        </div>
        <div className="option-conflict-confirmation__price">
          {priceContainer}
        </div>
      </div>
      {added && (
        <div className="option-conflict-containter">
          <OptionsList
            options={addedPackages?.items}
            label={addedPackages?.header}
            isAddedSection={true}
            isPackageOption={true}
          />
          <OptionsList
            options={addedOptions?.items}
            label={addedOptions?.header}
            isAddedSection={true}
            isPackageOption={false}
            className="option-conflict__options-grid"
          />
        </div>
      )}
      {removed && (
        <div className="option-conflict-containter">
          <OptionsList
            options={removedPackages?.items}
            label={removedPackages?.header}
            isAddedSection={false}
            isPackageOption={true}
          />
          <OptionsList
            options={removedOptions?.items}
            label={removedOptions?.header}
            isAddedSection={false}
            isPackageOption={false}
          />
        </div>
      )}
    </>
  );
};

export default OptionConflictConfirmation;
